var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.48293 9.50866L1.35707 6.36451L1.35652 6.36506C1.25062 6.25855 1.251 6.08622 1.35736 5.98017C1.3753 5.96228 1.39512 5.94743 1.41616 5.9356C1.78189 5.69841 2.22203 5.60305 2.66947 5.64294C3.05188 5.67703 3.44007 5.81022 3.79035 6.03823L8.61734 2.4442C8.49794 2.16785 8.44027 1.87701 8.44585 1.59556C8.45301 1.23473 8.56377 0.889135 8.78114 0.606558L8.78047 0.606048C8.87209 0.486987 9.04275 0.464849 9.16163 0.556596C9.17694 0.568406 9.19063 0.581547 9.20269 0.595699L11.3034 2.70867L13.4187 4.8364L13.4193 4.83585C13.5252 4.94236 13.5248 5.1147 13.4184 5.22075C13.4047 5.23444 13.3899 5.24635 13.3742 5.25649C13.0946 5.46427 12.7552 5.56944 12.4012 5.57494C12.1209 5.57928 11.831 5.52013 11.5555 5.39912L7.94551 10.2173C8.17229 10.5696 8.3039 10.959 8.33623 11.3418C8.37459 11.7959 8.27339 12.2428 8.02609 12.6125L7.80103 12.4616L8.02681 12.613C7.94327 12.7379 7.77446 12.7713 7.64976 12.6877C7.62842 12.6733 7.60973 12.6565 7.59386 12.6378L4.48292 9.50866L4.48293 9.50866Z",
    fill: "#7B7B7B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.35422 9.71421L0.5 13.498L4.2783 8.63672L5.35422 9.71421Z",
    fill: "#7B7B7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinIcon);
export default __webpack_public_path__ + "static/media/pin_icon.14ddce65511392131aa58df2e176e6e1.svg";
export { ForwardRef as ReactComponent };